import FieldProto from "../../../fields3/proto/field-proto"
import FieldDescriptionEditor_FormElementView from "./render/form-element-view";
import FieldConfig from "../../proto/field-config";
import FieldDescriptionEditor_View from "./render/view";
import FieldDescriptionEditor_InlineEditable from "./render/inline-editable";

export default class FieldDescriptionEditor extends FieldProto {

    FIELD_DEFAULT_WIDTH = 200

    public showFieldsOptions        : boolean

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel          = "Rich editor"

        this.showFieldsOptions  = _.get(config, 'showFieldsOptions', true)

        _.assign(this.renderComponents,{

            view                    : FieldDescriptionEditor_View,

            inlineEditable          : FieldDescriptionEditor_InlineEditable,

            formElementView         : FieldDescriptionEditor_FormElementView
        })
    }


}
